import { render, staticRenderFns } from "./ProductStatsNavigation.vue?vue&type=template&id=c313dc8a"
import script from "./ProductStatsNavigation.vue?vue&type=script&lang=js"
export * from "./ProductStatsNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports